import { WIDGET_TYPES } from 'common/Widgets/constants';

import { FEES_DATA_TEST_ATTR } from '../constants/fees';
import { raiseUnderscore } from '../utils/helpers/string';

export const generateFeesDataTestId = (field: string, type = ''): string => {
  return `${FEES_DATA_TEST_ATTR.PREFIX}-${raiseUnderscore(field)}${type}`.toLowerCase();
};

export const generateWidgetHeaderTitleDataTestId = (type: number, widgetName: string): string | undefined => {
  switch (type) {
    case WIDGET_TYPES.AI_INSIGHTS:
      return 'ai-insights-widget-title';
    default:
      return `${widgetName.toLowerCase().replace(/\s+/g, '-')}-widget-title`;
  }
};
